import "@/App.css";
import { ParticlesBackground } from "./components/ParticlesBackground";
import { HeroSection } from "./components/sections/HeroSection";
import { ProblemSection } from "./components/sections/ProblemSection";
import { DifferentiatorSection } from "./components/sections/DifferentiatorSection";
import { ResultsSection } from "./components/sections/ResultsSection";
import { TargetSection } from "./components/sections/TargetSection";
import { PackSection } from "./components/sections/PackSection";
import { BonusSection } from "./components/sections/BonusSection";
import { ProcessSection } from "./components/sections/ProcessSection";
import { PricingSection } from "./components/sections/PricingSection";
import { FAQSection } from "./components/sections/FAQSection";
import { FinalCTASection } from "./components/sections/FinalCTASection";
import { Footer } from "./components/sections/Footer";

function App() {
  return (
    <div className="App">
      {/* Particles background - fixed position */}
      <ParticlesBackground />
      
      {/* Main content */}
      <main className="main-content">
        <HeroSection />
        <ProblemSection />
        <DifferentiatorSection />
        <ResultsSection />
        <TargetSection />
        <PackSection />
        <BonusSection />
        <ProcessSection />
        <PricingSection />
        <FAQSection />
        <FinalCTASection />
        <Footer />
      </main>
    </div>
  );
}

export default App;
